// import { useState } from "react";

// export default function useTable(pageNumber = 0, limitCount = 10) {
//   const [page, setPage] = useState(pageNumber);
//   const [limit, setLimit] = useState(limitCount);
//   const [isFirstPage, setIsFirstPage] = useState(false);

//   const handlePagination = (
//     paginationPage: number,
//     paginationLimit: number
//   ) => {
//     setPage(paginationPage);
//     setLimit(paginationLimit);
//   };

//   const handleLimit = (val: number) => {
//     setLimit(Number(val));
//   };

//   const handleSetFirstPage = (val: boolean) => {
//     setIsFirstPage(val);
//   };

//   return {
//     page,
//     limit,
//     isFirstPage,
//     handleLimit,
//     handlePagination,
//     handleSetFirstPage,
//   };
// }

import { useCallback, useEffect, useState } from "react";

export default function useTable(pageNumber = 1, limitCount = 10) {
  const [page, setPage] = useState(pageNumber);
  const [limit, setLimit] = useState(limitCount);
  const [isResetPagination, setIsResetPagination] = useState(false);

  const handleLimit = (val: number) => {
    setLimit(Number(val));
  };

  const handlePagination = useCallback(
    (paginationPage: number, paginationLimit: number) => {
      setPage(paginationPage);
      setLimit(paginationLimit);
    },
    []
  );

  const resetPagination = () => {
    setIsResetPagination(true);
  };

  // When filtering, redirect table in first page
  useEffect(() => {
    if (isResetPagination) {
      handlePagination(pageNumber, limitCount);
      setIsResetPagination(false);
    }
  }, [handlePagination, isResetPagination, limitCount, pageNumber]);

  return {
    page,
    limit,
    handleLimit,
    handlePagination,
    resetPagination,
  };
}
